module.exports = __webpack_public_path__ + "static/media/weddings-investment.f738bcf3.png";